// Program switch: the rebuild runs server-side as a background job, so the client
// polls behind the engine overlay instead of holding a request open (edge timeout).
export const SWITCH_ERROR_MESSAGE = "We couldn't finish building your program. Please try again.";

const POLL_INTERVAL_MS = 2000;
const POLL_TIMEOUT_MS = 180000;

export async function runProgramSwitch(api, { target }) {
  const { data } = await api.post('/programs/switch', { target });
  if (!data?.job_id) return data; // legacy synchronous response

  const startedAt = Date.now();
  while (Date.now() - startedAt < POLL_TIMEOUT_MS) {
    await new Promise(resolve => setTimeout(resolve, POLL_INTERVAL_MS));
    let status;
    try {
      status = (await api.get(`/programs/switch-status/${data.job_id}`)).data;
    } catch {
      continue; // transient network hiccup — keep polling
    }
    if (status.status === 'ready' || status.status === 'action_required') {
      return status.result || {};
    }
    if (status.status === 'failed') {
      throw new Error(SWITCH_ERROR_MESSAGE);
    }
  }
  throw new Error(SWITCH_ERROR_MESSAGE);
}

export function clearPlanCaches() {
  try { localStorage.removeItem('workout_plan_cache'); } catch {}
  try { localStorage.removeItem('bm_active_workout'); } catch {}
}
